export const CANNEDCOMMAND_CREATE_EDIT_OPEN_MODAL = "CANNEDCOMMAND_CREATE_EDIT_OPEN_MODAL";

export const CANNEDCOMMAND_CREATE_REQUEST = "CANNEDCOMMAND_CREATE_REQUEST";
export const CANNEDCOMMAND_CREATE_RESULT = "CANNEDCOMMAND_CREATE_RESULT";

export const CANNEDCOMMAND_UPDATE_REQUEST = "CANNEDCOMMAND_UPDATE_REQUEST";
export const CANNEDCOMMAND_UPDATE_RESULT = "CANNEDCOMMAND_UPDATE_RESULT";

export const CANNEDCOMMAND_GET_REQUEST = "CANNEDCOMMAND_GET_REQUEST";
export const CANNEDCOMMAND_GET_RESULT = "CANNEDCOMMAND_GET_RESULT";